module.exports = __webpack_public_path__ + "img/wechat_logo.556e9765.svg";